import * as _ from 'lodash';

// import PersonType from './person-type';

/**
 * <fields>
			<field name="TextUserID" type="long" generateIfNull="true" />
			<field name="AccountID" type="long" useAccountIDIfNull="true" />
			<field name="CountryCode" type="text" />
			<field name="AreaCode" type="text" />
			<field name="PhoneNumber" type="text" />
			<field name="InternalPhoneNumber" type="text" />
			<field name="City" type="text" />
			<field name="State" type="text" />
			<field name="CountryAbbrev" type="text" />
			<field name="ChatName" type="text" />
			<field name="Created" type="created" />
			<field name="UserID" type="text" />
			<field name="FirstName" type="text" />
			<field name="LastName" type="text" />
			<field name="Email" type="text" />
			<field name="Gender" type="text" />
			<field name="ProfilePic" type="text" />
			<field name="Locale" type="text" />
			<field name="TimeZone" type="double" />
			<field name="Deleted" type="datetime" />
 </fields>
 * @param textChatUser
 * @constructor
 */


class TextChatUser {
  public IsTyping;

  static comparator(user1, user2) {
    return user1.TextUserID === user2.TextUserID;
  }

  static wrap(event) {
    return new TextChatUser(event.data);
  }

  static wrapAll(eventList) {
    return _.map(eventList, TextChatUser.wrap);
  }

  constructor(user) {
    _.assign(this, user);
  }

  isEquals(user) {
    return TextChatUser.comparator(this, user);
  }
}

function factory() {
  return TextChatUser;
}

export { TextChatUser, factory };
